
import {
  DocumentFilter, fileDocumentLicenseOptions, Label, StatusHistoryFilter,
  languageOptions,
} from '@/model';
import labels, { labelSorter } from '@/store/labels';
import publishers from '@/store/publisher';
import realms from '@/store/realms';
import users from '@/store/users';
import { notEmpty } from '@/util/array-util';

import UserPicker from '@/components/UserPicker.vue';
import LabelPicker from '@/components/LabelPicker.vue';
import RealmPicker from '@/components/RealmPicker.vue';
import PublisherPicker from '@/components/PublisherPicker.vue';
import DatePicker from '@/components/DatePicker.vue';
import YearPicker from '@/components/YearPicker.vue';
import { documentStatusOptions } from '@/store/ui-config';
import Vue from 'vue';

export default Vue.extend({
  components: {
    UserPicker,
    LabelPicker,
    RealmPicker,
    PublisherPicker,
    DatePicker,
    YearPicker,
  },
  props: {
    value: { type: Object as () => DocumentFilter | undefined },
  },
  data() {
    return {
      editFilter: { ...this.value },
    };
  },

  computed: {
    licenseOptions(): typeof fileDocumentLicenseOptions | undefined {
      return fileDocumentLicenseOptions;
    },
    languageOptions(): typeof languageOptions {
      return languageOptions;
    },
  },

  watch: {
    value: {
      handler(v: DocumentFilter) {
        this.editFilter = { ...v };
      },
      immediate: true,
    },
  },

  methods: {
    fileDocumentStatusOptions(
      statuses?: DocumentFilter['statuses'],
      historyStatuses?: StatusHistoryFilter['statuses'],
    ) {
      return documentStatusOptions([
        ...(statuses ?? []),
        ...(historyStatuses ?? []),
      ]);
    },
    input() {
      this.$emit('input', this.editFilter);
    },
    usersLookup(userIds: readonly number[] | undefined) {
      return this.lookups(userIds, users.getters.lookup);
    },
    realmLookup(realmIds: readonly number[] | undefined) {
      return this.lookups(realmIds, realms.getters.lookup);
    },
    publisherLookup(publisherIds: readonly number[] | undefined) {
      return this.lookups(publisherIds, publishers.getters.lookup);
    },
    labelLookup(labelIds: readonly number[] | undefined): Label[] {
      return this.lookups(labelIds, labels.getters.lookup)
        .sort(labelSorter(['type', 'alpha']));
    },
    lookups<T>(ids: readonly number[] | undefined, index: ReadonlyMap<number, T>): T[] {
      return ids?.map((id) => index.get(id)).filter(notEmpty) || [];
    },
    toIds(items: { id: number }[]) {
      return items.map((item) => item.id);
    },
    changeFilter(key: keyof DocumentFilter, value: DocumentFilter[typeof key]) {
      this.editFilter = { ...this.editFilter, [key]: value };
      this.input();
    },
    changeStatusFilter(key: keyof StatusHistoryFilter, value: StatusHistoryFilter[typeof key]) {
      const statusHistory = this.editFilter.statusHistory || {};
      this.editFilter = { ...this.editFilter, statusHistory: { ...statusHistory, [key]: value } };
      this.input();
    },
    reset() {
      this.editFilter = {};
      this.input();
    },
  },

});
